module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/axios/index.js
// module id = 242
// module chunks = 0